import { render, staticRenderFns } from "./material-db-detail.view.vue?vue&type=template&id=c1193220&"
import script from "./material-db-detail.view.vue?vue&type=script&lang=ts&"
export * from "./material-db-detail.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports